define(
    'DC.CartCustomization.CartExtension',
    [
        'DC.CartCustomization.CartExtension.View',
        'Cart.Lines.View',
        'Backbone'
    ],
    function (CartExtensionView, CartLinesView, Backbone) {
        'use strict';
        return {
            mountToApp: function mountToApp(container) {
                var layout = container.getComponent('Layout');
                var cart = container.getComponent('Cart');
                if (layout && cart) {
                    console.log('Cart and Layout components found. Initializing.');
                    // Extend Cart.Lines.View to include your custom child views
                    _.extend(CartLinesView.prototype, {
                        childViews: _.extend({}, CartLinesView.prototype.childViews, {
                            'Item.Summary.View': function (options) {
                                var lineModel = new Backbone.Model(options.model);
                                console.log(
                                    'Rendering custom child view for line:',
                                    lineModel.toJSON()
                                );
                                return new CartExtensionView({
                                    model: lineModel,
                                    container: container
                                });
                            }
                        })
                    });
                    
                } else {
                    console.error('Layout or Cart component is missing.');
                }
            }
        };
    }
);
